import { useTranslation } from 'react-i18next';

import { BlockingReasonRow } from './BlockingReasonRow';

export function RequiredDocumentReason() {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.waiverRequired.title')}
      message={t('blockingReasons.waiverRequired.message')}
    />
  );
}
